import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="read-more"
export default class ReadMoreController extends Controller {
  static targets = ["content", "moreButton", "lessButton"];

  static classes = ["truncate", "hide"];

  static values = {
    lines: Number
  };

  connect() {
    this.isExpanded = false;
    this.render();

    this.resizeObserver = new ResizeObserver(() => {
      if (!this.isExpanded) this.render();
    });

    this.resizeObserver.observe(this.contentTarget);
  }

  disconnect() {
    this.resizeObserver?.disconnect();
  }

  render() {
    if (this.isExpanded) return;

    this.showAllContent();

    requestAnimationFrame(() => {
      if (!this.contentTarget.isConnected || this.isExpanded) return;

      const styles = getComputedStyle(this.contentTarget);
      const lineHeight = Number.parseFloat(styles.lineHeight);
      const contentHeight = this.contentTarget.getBoundingClientRect().height;
      const expectedHeight = lineHeight * this.linesValue;

      const shouldTruncate = contentHeight > expectedHeight + 2;

      if (shouldTruncate) {
        this.truncateContent();
        this.show(this.moreButtonTarget);
      } else {
        this.hide(this.moreButtonTarget);
        this.hide(this.lessButtonTarget);
      }
    });
  }

  showMore() {
    this.isExpanded = true;
    this.showAllContent();
    this.hide(this.moreButtonTarget);
    this.show(this.lessButtonTarget);
  }

  showLess() {
    this.isExpanded = false;
    this.truncateContent();
    this.show(this.moreButtonTarget);
    this.hide(this.lessButtonTarget);
  }

  showAllContent() {
    this.contentTarget.classList.remove(this.truncateClass);
  }

  truncateContent() {
    this.contentTarget.style.webkitLineClamp = this.linesValue;
    this.contentTarget.classList.add(this.truncateClass);
  }

  expectedHeight() {
    const lineHeight = Number.parseFloat(getComputedStyle(this.contentTarget).lineHeight);
    return lineHeight * this.linesValue;
  }

  show(target) {
    target.classList.remove(this.hideClass);
  }

  hide(target) {
    target.classList.add(this.hideClass);
  }
}
